import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a GA4 page_view event on every React Router navigation.
 *
 * The base gtag snippet in /public/index.html only counts the FIRST page load,
 * so without this hook GA4 would only see "/" and miss every subsequent route
 * change. Mounting this once inside <BrowserRouter> fixes that.
 */
export default function GAPageViewTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    const path = pathname + (search || "");
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, search]);

  return null;
}
